import React, { Component } from "react";
class TimeDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: 'lun. 1 jan. 1970',
            heure: '00:00',
        }

    }
    render() {
        const boat = this.props.boatData;
        if (boat) {
            const date = new Date(Date.now());
            const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
            let dateCorrectedHour = date.getUTCHours() + boat.weather.timezone / 60 / 60;
            if (dateCorrectedHour == 24) dateCorrectedHour = 0;

            const dateDisplay = date.toLocaleDateString('fr-FR', options);
            let minuteDisplay = date.getUTCMinutes();
            if (minuteDisplay < 10) minuteDisplay = '0' + minuteDisplay;

            return (
                <div id="time_display">
                    <span class="date">{dateDisplay}</span><br />
                    {dateCorrectedHour}:{minuteDisplay}
                </div>
            );
        } else {
            return <div></div>
        }
    }
}


export default TimeDisplay;
